import { SearchApi } from 'clientSDK';

// Shared search cache (moved from services/searchCache.js)
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
const MAX_ENTRIES = 100;

const cache = new Map(); // key -> { data, timestamp }

const isFresh = (timestamp) => Date.now() - timestamp < CACHE_TTL_MS;

const getExactFresh = (key) => {
  const entry = cache.get(key);
  if (entry && isFresh(entry.timestamp)) {
    return entry.data;
  }
  return null;
};

const getPrefixFilteredFresh = (prefixKey) => {
  for (const [key, value] of cache.entries()) {
    if (key.startsWith(prefixKey) && isFresh(value.timestamp)) {
      const data = value.data || {};
      const filteredData = {
        collections: Array.isArray(data.collections)
          ? data.collections.filter(
              (c) =>
                c?.name?.toLowerCase().includes(prefixKey) ||
                c?.symbol?.toLowerCase().includes(prefixKey),
            )
          : undefined,
        accounts: Array.isArray(data.accounts)
          ? data.accounts.filter(
              (a) =>
                a?.username?.toLowerCase().includes(prefixKey) ||
                a?.address?.toLowerCase().includes(prefixKey),
            )
          : undefined,
        items: Array.isArray(data.items)
          ? data.items.filter((i) => i?.name?.toLowerCase().includes(prefixKey))
          : undefined,
      };
      return filteredData;
    }
  }
  return null;
};

const set = (key, data) => {
  cache.set(key, { data, timestamp: Date.now() });
  if (cache.size > MAX_ENTRIES) {
    const firstKey = cache.keys().next().value;
    if (firstKey) {
      cache.delete(firstKey);
    }
  }
};

const clear = () => cache.clear();

export const searchCache = {
  CACHE_TTL_MS,
  getExactFresh,
  getPrefixFilteredFresh,
  set,
  clear,
};

// Search service
const searchApi = new SearchApi();
export default {
  search: (searchPhrase, signal) => searchApi.search(searchPhrase, { signal, timeout: 10000 }),
};
